import React from 'react';
import { useLayout } from '@ukpostbox/frontend-framework';
import { MailItemContentType } from '../Types/MailItemTypes';
import { InForwardingBatchInfo } from './Components/InForwardingBatchInfo';
import { MailItemContents } from './Components/MailItemContents';
import { MailItemMeta } from './Components/MailItemMeta';
import { MailItemMetaPills } from './Components/MailItemMetaPills';

function MailItemContent(props: MailItemContentType) {
	const { isTiny, isSmall, isMedium } = useLayout();

	return (
		<>
			{(isTiny || isSmall || isMedium) && (
				<div className='pt-sm pb-sm'>
					<MailItemMetaPills />
				</div>
			)}
			<div className='row'>
				<div className='col-xs-12 col-lg-4 col-xl-3'>
					<MailItemMeta mailboxTopBarHeight={props.mailboxTopBarHeight} />
				</div>
				<div className='col-xs-12 col-lg-8 col-xl-9'>
					<InForwardingBatchInfo />
					<MailItemContents />
				</div>
			</div>
		</>
	);
}

export { MailItemContent };
